export default [
    {
        path: '/current-activity-reports',
        name: 'current-activity-reports',
        component: () => import(/* webpackChunkName: "campus-addresses" */ '@/components/AppModuleNavigator.vue'),
        props: {parentRouteName: 'current-activity-reports'},
        meta: {
            title: 'CURRENT ACTIVITY REPORTS',
            icon: 'mdi-table-search'
        },
        children: [
            {
                path: 'construction',
                name: 'current-activity-reports-construction',
                component: () => import(/* webpackChunkName: "campus-addresses" */ '@/modules/currentActivityReports/pages/CurrentActivityReports.vue'),
                props: {additionStatus: 'CONSTRUCT'},
                meta: {
                    title: 'CONSTRUCT',
                    icon: 'mdi-table-search',
                    pageTitle: 'Current Activity Report - In Construction',
                    gtm: 'current-activity-reports-construction'
                }
            },
            {
                path: 'design',
                name: 'current-activity-reports-design',
                component: () => import(/* webpackChunkName: "campus-addresses" */ '@/modules/currentActivityReports/pages/CurrentActivityReports.vue'),
                props: {additionStatus: 'DESIGN'},
                meta: {
                    title: 'DESIGN',
                    icon: 'mdi-table-search',
                    pageTitle: 'Current Activity Report - In Design',
                    gtm: 'current-activity-reports-design'
                }
            },
            {
                path: 'plan-study',
                name: 'current-activity-reports-plan-study',
                component: () => import(/* webpackChunkName: "campus-addresses" */ '@/modules/currentActivityReports/pages/CurrentActivityReports.vue'),
                props: {additionStatus: 'PLAN/STUDY'},
                meta: {
                    title: 'PLAN/STUDY',
                    icon: 'mdi-table-search',
                    pageTitle: 'Current Activity Report - In Plan/Study',
                    gtm: 'current-activity-reports-plan-study'
                }
            },
            {
                path: '/',
                redirect: '/current-activity-reports/construct',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    }
]
